import React from 'react';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import utils from '../../lib/utils';
import Loading from '../common/Loading';

const DropdownIndicator = (props) => (
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <i className="material-icons custom">arrow_drop_down</i>
    </components.DropdownIndicator>
  )
);

const CustomDropdownIndicator = (searchResults, selectedBusiness, inputValue, onClickHandler) => (props) => {
  const shouldShow = (searchResults && searchResults.length > 0) || selectedBusiness || inputValue;
  return (
    <div
      onClick={shouldShow ? onClickHandler : undefined}
      style={{
        visibility: shouldShow ? 'visible' : 'hidden',
        width: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <DropdownIndicator {...props} />
    </div>
  );
};

const NoSeparator = () => null;

const selectStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#007bff' : 'white',
    padding: '8px 12px',
    color: '#000',
    fontSize: '13px',
    ':hover': { backgroundColor: '#f0f0f0' },
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 200,
    overflowY: 'auto',
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    padding: '2px 4px',
    boxShadow: 'none',
    outline: 'none',
    minHeight: '34px',
    fontSize: '13px',
    width: '100%',
    '&:hover': { border: '1px solid #CFD0D1' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 4px',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

class HeaderBusinessSelect extends React.Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.containerRef = React.createRef();
    this.state = {
      selectedBusiness: props.studioName
        ? { value: '', label: props.studioName }
        : null,
      searchResults: [],
      isLoading: false,
      isSwitching: false,
      inputValue: '',
      menuIsOpen: false,
    };
    this.searchTimer = null;
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleDropdownIndicatorClick = this.handleDropdownIndicatorClick.bind(this);
    this.filterOption = this.filterOption.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  handleClickOutside(event) {
    if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
      this.setState({ menuIsOpen: false });
    }
  }

  async fetchData(searchTerm) {
    const email = utils.getCookie('cs_authe');
    const password = utils.getCookie('cs_authp');
    if (!email || !password) return;

    try {
      this.setState({ isLoading: true });
      const basicAuthToken = btoa(`${email}:${password}`);
      const response = await fetch(
        `${window.Config.API_URL}/bookingSWs/query?searchTerm=${encodeURIComponent(searchTerm)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${basicAuthToken}`,
          },
        },
      );
      const data = await response.json();
      const searchResults = data.map((item) => ({
        value: item.id,
        label: item.name,
        status: item.status,
      }));
      this.setState({
        searchResults,
        isLoading: false,
        menuIsOpen: true,
      });
    } catch (error) {
      console.error('Error fetching businesses:', error);
      this.setState({ isLoading: false, searchResults: [] });
    }
  }

  handleInputChange(inputValue, { action }) {
    if (action === 'input-change') {
      this.setState({ inputValue });
      if (this.searchTimer) clearTimeout(this.searchTimer);
      if (inputValue.trim()) {
        this.searchTimer = setTimeout(() => {
          this.fetchData(inputValue);
        }, 800);
      } else {
        this.setState({ searchResults: [], menuIsOpen: false });
      }
    }
    return this.state.inputValue;
  }

  handleSelect(business, { action }) {
    if (action === 'clear') {
      this.setState({
        selectedBusiness: null,
        inputValue: '',
        searchResults: [],
        menuIsOpen: false,
      });
      return;
    }

    if (!business) return;

    this.setState({
      selectedBusiness: business,
      inputValue: '',
      menuIsOpen: false,
      isSwitching: true,
    });

    const email = utils.getCookie('cs_authe');
    const password = utils.getCookie('cs_authp');

    if (email && password) {
      const basicAuthToken = btoa(`${email}:${password}`);
      fetch(`${window.Config.API_URL}/login?business_id=${business.value}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${basicAuthToken}`,
        },
        credentials: 'include',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Login failed');
          }
          return response.json();
        })
        .then((resp) => {
          if (resp && resp.data) {
            const d = resp.data;
            // Clear old cookies first
            utils.removeCookie('user');
            utils.removeCookie('subscription_status');
            utils.removeCookie('features');
            utils.removeCookie('domain');
            utils.removeCookie('domain_keywords');
            utils.removeCookie('booking_software');
            utils.removeCookie('brand_ids');
            utils.removeCookie('studio_id');
            utils.removeCookie('studio_name');
            utils.removeCookie('role');
            utils.removeCookie('dashboard_settings');
            utils.removeCookie('is_phone_assigned');
            utils.removeCookie('tl_user_login');
            utils.removeCookie('is_brand');
            utils.removeCookie('weave_phone');
            localStorage.clear();
            sessionStorage.clear();
            // Set new cookies
            utils.setCookie('user', d.id);
            utils.setCookie('subscription_status', d.subscription_status);
            utils.setCookie('features', d.features);
            utils.setCookie('domain', d.domain);
            utils.setCookie('domain_keywords', d.domain_keywords);
            utils.setCookie('booking_software', d.booking_software);
            utils.setCookie('brand_ids', d.brand_ids);
            utils.setCookie('studio_id', d.studio_id);
            utils.setCookie('studio_name', d.studio_name);
            utils.setCookie('role', d.role);
            utils.setCookie('is_phone_assigned', d.is_phone_assigned);
            utils.setCookie('dashboard_settings', d.dashboard_settings?.show_notifications || false);
            utils.setCookie('tl_user_login', true);
            utils.setCookie('is_brand', d.is_brand);
            utils.setCookie('weave_phone', d.weave_phone);
            // Small delay to ensure cookies are written before reload
            setTimeout(() => {
              window.location.href = '/';
            }, 100);
          } else {
            this.setState({ isSwitching: false });
            alert('Failed to switch business. Please try again.');
          }
        })
        .catch(() => {
          this.setState({ isSwitching: false });
          alert('Failed to switch business. Please try again.');
        });
    }
  }

  handleMenuClose() {
    this.setState({ menuIsOpen: false });
  }

  handleDropdownIndicatorClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const { searchResults } = this.state;
    if (searchResults.length > 0) {
      this.setState({ menuIsOpen: !this.state.menuIsOpen });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  filterOption() { return true; }

  render() {
    const { selectedBusiness, searchResults, isLoading, menuIsOpen, inputValue, isSwitching } = this.state;

    return (
      <div className="header-business-select" ref={this.containerRef}>
        {isSwitching && (
          <div className="header-business-select__overlay">
            <Loading style={{ width: '50px', height: '50px' }} />
            <span>Switching business...</span>
          </div>
        )}
        <Select
          ref={this.selectRef}
          options={searchResults}
          onChange={this.handleSelect}
          onInputChange={this.handleInputChange}
          onMenuClose={this.handleMenuClose}
          isLoading={isLoading}
          value={selectedBusiness}
          inputValue={inputValue}
          menuIsOpen={menuIsOpen}
          closeMenuOnSelect={true}
          openMenuOnFocus={false}
          openMenuOnClick={false}
          filterOption={this.filterOption}
          className="header-business-select__field"
          components={{
            DropdownIndicator: CustomDropdownIndicator(searchResults, selectedBusiness, inputValue, this.handleDropdownIndicatorClick),
            IndicatorSeparator: NoSeparator,
          }}
          styles={selectStyles}
          placeholder="Search business name or ID"
          isClearable={true}
          getOptionLabel={(option) => (option.value ? `${option.label} (${option.value}${option.status ? ` - ${option.status}` : ''})` : option.label)}
          blurInputOnSelect={false}
        />
      </div>
    );
  }
}

export default connect()(HeaderBusinessSelect);
